import { createSlice } from "@reduxjs/toolkit"


export const initialState = {
    total:0
}



const totalSlice = createSlice({
    name:"total",
    initialState,
    reducers: {
        
        setTotal: (state, action)=> {
            state.total = action.payload
        }
            
    }

}
)

export default totalSlice.reducer

export const{setTotal} = totalSlice.actions